import { SkipLinkSelector, SkipLinkType } from "./types"

export const PATHS_WITHOUT_NAV_SKIP_LINK = [
  "/snap/student",
  "/mastery/resources",
  "/truscore/practice-tests/:program/test-taking"
]

export const SKIP_LINKS_SELECTORS: Record<SkipLinkType, SkipLinkSelector> = {
  navigationTopBar: { value: "NAVIGATION_TOP_BAR", type: "id" },
  navigationDropdowns: { value: "NAVIGATION_DROPDOWNS", type: "id" },
  navigationSubNavBar: { value: "NAVIGATION_SUB_NAV_BAR", type: "id" },
  appFilters: { value: "APP_FILTERS", type: "id" },
  mainContent: { value: "main", type: "selector" }
}

export const SKIP_LINKS_TITLES = {
  appFilters: "Skip To Filters",
  mainContent: "Skip To Main Content",
  navigation: "Skip To Navigation"
}

export const getTargets = (
  targets: [string, SkipLinkSelector][]
): [string, HTMLElement][] =>
  targets.map(([targetType, target]) => {
    if (target.type === "id") {
      return [targetType, document.getElementById(target.value)]
    }

    return [targetType, document.querySelector(target.value)]
  })
